module.exports = __webpack_public_path__ + "static/media/cat.0fe41603.glb";